// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"fbed6bd8","912":"602c1da2"}[chunkId] + ".chunk.css";
};